"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const routes = [
    {
        path: '/',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Default.vue'))),
        children: [
            { path: '', component: () => Promise.resolve().then(() => __importStar(require('pages/InventoryItem/Index.vue'))) },
            { path: 'inventory_item/add', component: () => Promise.resolve().then(() => __importStar(require('pages/InventoryItem/InventoryItem.vue'))) },
            { path: 'inventory_item/edit/:id', component: () => Promise.resolve().then(() => __importStar(require('pages/InventoryItem/InventoryItem.vue'))) }
        ]
    },
    //
    // Auth / Profile
    //
    {
        path: '/login',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Login.vue'))),
        children: [
            { path: '', component: () => Promise.resolve().then(() => __importStar(require('pages/Auth/Login.vue'))) }
        ]
    },
    {
        path: '/my',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Default.vue'))),
        children: [
            { path: 'profile', component: () => Promise.resolve().then(() => __importStar(require('pages/My/Profile.vue'))) },
            { path: 'password', component: () => Promise.resolve().then(() => __importStar(require('pages/My/Password.vue'))) }
        ]
    },
    //
    // TEST routes; only for DEVELOPMENT
    //
    {
        path: '/sample',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Default.vue'))),
        children: [
            { path: '', component: () => Promise.resolve().then(() => __importStar(require('pages/Sample.vue'))) }
        ]
    },
    {
        path: '/auth-guest',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Default.vue'))),
        children: [
            { path: '', component: () => Promise.resolve().then(() => __importStar(require('pages/Test/AuthGuest.vue'))) }
        ]
    },
    {
        path: '/auth-user',
        component: () => Promise.resolve().then(() => __importStar(require('layouts/Default.vue'))),
        children: [
            { path: '', component: () => Promise.resolve().then(() => __importStar(require('pages/Test/AuthUser.vue'))) }
        ]
    },
    // Always leave this as last one,
    // but you can also remove it
    {
        path: '/:catchAll(.*)*',
        component: () => Promise.resolve().then(() => __importStar(require('pages/Error404.vue'))),
    }
];
// Always leave this as last one
/*if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}*/
exports.default = routes;
